import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useGoogleAnalytics = (GA_TRACKING_ID) => {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;
        window.gtag("config", GA_TRACKING_ID, { page_location: location.pathname });
    }, [location, GA_TRACKING_ID]);
};

export default useGoogleAnalytics;
